import React, { useState, useReducer, useEffect } from "react";
import { useSWRConfig } from "swr";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";
import DeleteModal from "../Components/Modals/Delete-modal";
import PaginatedTableDynamic from "../Components/Tables/PaginatedTableDynamic";
import ToastError from "../Components/ToastError";
import { data } from "autoprefixer";
import { toDateISOString } from "../../Services/string.service";

// Services
import { modelsService } from "../../Services/models.service";
import { manufacturerService } from "../../Services/manufacturer.service";
import { categoryService } from "../../Services/category.service";

// Icons
import { SiAddthis } from "react-icons/si";

// Constants
const _pageTitle = "Cadastro de Modelos";
const _listTitle = "Lista de Modelos";
const _registerTitle = "Dado do Modelo";

const formInitialValues = {
  id: 0,
  name: "",
  infoCar: "N",
  active: "S",
  automakerId: 0,
  vehicleCategoryId: 0,
  Created: "",
};

const formReducer = (state, event) => {
  if (event.reset) {
    return formInitialValues;
  }
  return {
    ...state,
    [event.name]: event.value,
  };
};

export default function Models() {
  const [formData, setFormData] = useReducer(formReducer, {});
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isDeleting, setIsDeleting] = useState({ show: false, itemName: "" });
  const [editingItem, setEditingItem] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [listManufacturers, setListManufacturers] = useState([]);
  const [listCategories, setListCategories] = useState([]);
  const [filter, setFilter] = useState("0");
  const [fetchApiUrl, setFetchApi] = useState("models");

  const dispatch = useDispatch();
  dispatch({ type: "title", value: _pageTitle });

  const { mutate } = useSWRConfig();

  const handleCloseModal = () => {
    setIsDeleting({ show: false, itemName: "" });
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  const handleChangeFilter = (event) => {
    if (event.target.value) {
      setFetchApi(`models?automakerId=${event.target.value}`);
      setFilter(event.target.value);
    } else {
      // Limpa o filtro
      setFilter("");
      setFetchApi("models");
    }
  };

  const onEdit = (item) => {
    setEditingItem(item);
    setFormData({
      name: "id",
      value: item.categoryId,
    });

    setFormData({
      name: "name",
      value: item.description,
    });

    setFormData({
      name: "automakerId",
      value: item.automakerId,
    });

    setFormData({
      name: "vehicleCategoryId",
      value: item.categoryId,
    });

    setFormData({
      name: "infoCar",
      value: item.infoCar,
    });

    setShowForm(true);
  };

  const onNew = () => {
    setFormData({
      reset: true,
    });
    setShowForm(true);
    setEditingItem({});
  };

  const onCancel = () => {
    setFormData({
      reset: true,
    });
    setShowForm(false);
    setEditingItem({});
  };

  const onCloseToast = () => {
    setShowToast(false);
  };

  const onDelete = (item) => {
    setEditingItem(item);
    setIsDeleting({
      show: true,
      itemName: item.description,
      itemRemoveId: item.vehicleModelId,
    });
  };

  const handleRemove = async (id) => {
    if (id) {
      try {
        setIsLoading(true);

        editingItem.active = "N";
        editingItem.fipe = "0";


        await modelsService.update(editingItem);
        await mutate(fetchApiUrl, undefined, { revalidate: true });
      } catch (error) {
        console.log(error);
        setShowToast(true);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
          setShowForm(false);
          setShowToast(false);
          setFormData({
            reset: true,
          });
          setEditingItem({});
        }, 1000);
      }
    }
  };

  const onSave = async () => {
    if (formData.name && formData.automakerId && formData.vehicleCategoryId) {
      setIsLoading(true);

      const selectedManufacturer = listManufacturers.find(
        (m) => m.automakerId === Number(formData.automakerId)
      );

      const selectedCategory = listCategories.find(
        (c) => c.categoryId === Number(formData.vehicleCategoryId)
      );

      const payload = {
        description: formData.name,
        infoCar: formData.infoCar,
        fipe: "0",
        active: "S",
        AutomakerName: selectedManufacturer ? selectedManufacturer.description : "",
        CategoryName: selectedCategory ? selectedCategory.description : "",
        Created: toDateISOString(new Date()),
      };

      try {
        setIsLoading(true);

        if (formData.id) payload["id"] = Number(formData.id || 0);

        let response = "";
        if (payload.id > 0) response = await modelsService.update(payload);
        else response = await modelsService.create(payload);

        if (response == null) setShowToast(true);
        if (editingItem && response) {
          editingItem.description = payload.description;
          editingItem.infoCar = payload.infoCar;
          editingItem.fipe = payload.fipe;
          editingItem.active = payload.active;
          editingItem.AutomakerName = payload.AutomakerName;
          editingItem.CategoryName = payload.CategoryName;
          editingItem.created = payload.created;
          await mutate(fetchApiUrl, undefined, { revalidate: true });
        }
      } catch (error) {
        console.log(error);
        setShowToast(true);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
          setShowForm(false);
          setFormData({
            reset: true,
          });
          setEditingItem({});
        }, 1000);
      }
    }
  };


  useEffect(() => {
    (async () => {
      var manufacturers = await manufacturerService.list();
      setListManufacturers(manufacturers);
      setFilter(0);
      setFetchApi(`models?automakerId=0`);
      setListCategories(await categoryService.list());
    })();
  }, []);


  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        {isLoading ? <Spinner /> : ""}

        {showToast && (
          <ToastError show={showToast} closeToast={onCloseToast} />
        )}

        <DeleteModal
          itemName={isDeleting.itemName}
          itemRemoveId={isDeleting.itemRemoveId}
          callBackRemove={handleRemove}
          show={isDeleting.show}
          handleClose={handleCloseModal}
        />

        <div
          className="card"
          style={showForm || isLoading ? { display: "none" } : { display: "" }}
        >
          <div className="d-flex justify-content-between">
            <div className="p-2 card-header">
              <h5>{_listTitle}</h5>
            </div>
            <div className="p-2"></div>
            <div className="p-2">
              <SiAddthis className="icon-new" onClick={onNew} />
            </div>
          </div>
          <div className="p-2">
            <div className="col-sm-3">
              <label htmlFor="defaultSelect" className="form-label">
                Filtro por Montadora
              </label>
              <select
                name="manufacturer"
                className="form-control"
                onChange={handleChangeFilter}
                value={filter || ""}
              >
                <option value="">--Montadora--</option>
                {listManufacturers &&
                  listManufacturers.map((item, index) => (
                    <option key={index} value={item.automakerId}>
                      {item.description}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <PaginatedTableDynamic
            title="Montadoras"
            api={fetchApiUrl}
            pageSize={25}
            columns={["Id", "Descrição", "Montadora", "Categoria", "Ativo"]}
            fields={["vehicleModelId", "description", "automakerName", "categoryName", "active"]}
            onEdit={onEdit}
            onDelete={onDelete}
          />

        </div>

        <div
          className="row py-3"
          style={
            !showForm || isLoading ? { display: "none" } : { display: "block" }
          }
        >
          <div className="col-6">
            <div className="card">
              <h5 className="card-header">{_registerTitle}</h5>
              <div className="card-header">
                {formData.id > 0 ? (
                  <div className="row mb-3">
                    <label
                      className="col-sm-2 col-form-label"
                      htmlFor="basic-default-name"
                    >
                      ID
                    </label>
                    <div className="col-sm-10">
                      <label
                        className="col-sm-2 col-form-label"
                        htmlFor="basic-default-name"
                      >
                        {formData.id}
                      </label>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <input
                  type="hidden"
                  value={formData.infoCar || ""}
                  id="infoCar"
                  name="infoCar"
                />
                <div className="row mb-3">
                  <label
                    className="col-sm-2 col-form-label"
                    htmlFor="basic-default-name"
                  >
                    Nome
                  </label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      placeholder="Nome"
                      value={formData.name || ""}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    className="col-sm-2 col-form-label"
                    htmlFor="basic-default-name"
                  >
                    Montadora
                  </label>
                  <div className="col-sm-10">
                    <select
                      name="automakerId"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.automakerId || ""}
                    >
                      <option value="">--Montadora--</option>
                      {listManufacturers &&
                        listManufacturers.map((item, index) => (
                          <option key={index} value={item.automakerId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    className="col-sm-2 col-form-label"
                    htmlFor="basic-default-name"
                  >
                    Categoria
                  </label>
                  <div className="col-sm-10">
                    <select
                      name="vehicleCategoryId"
                      className="form-control"
                      onChange={handleChange}
                      value={formData.vehicleCategoryId || ""}
                    >
                      <option value="">--Categoria--</option>
                      {listCategories &&
                        listCategories.map((item, index) => (
                          <option key={index} value={item.categoryId}>
                            {item.description}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div
                  className="row justify-content-end"
                  style={{ textAlign: "end" }}
                >
                  <div className="col-ls-8 col-md-8 col-xs-12 mb-3">
                    <button
                      type="button"
                      className="btn btn-warning"
                      style={{ marginRight: "10px" }}
                      onClick={onCancel}
                    >
                      Cancelar
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={onSave}
                      disabled={isLoading}
                    >
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
